import React from 'react'

function AccountSystem() {
  return (
      <>
          <head>
              <title>نظام المحاسبة</title>
              <meta name="description" content="إدارة الشؤون المالية أصبحت أسهل مع نظام المحاسبة المتكامل من بروتك، الذي يوفر:" />
          </head>
          <div>
              <h1>نظام المحاسبة</h1>
              <p>إدارة الشؤون المالية أصبحت أسهل مع نظام المحاسبة المتكامل من بروتك، الذي يوفر:</p>
              <ol>
                  <li>  إدارة الفواتير والمصروفات تلقائيًا.</li>
                  <li>  تقارير مالية مفصلة بضغطة زر.</li>
              </ol>
              <p>💰 دقة محاسبية تمنع الأخطاء وتضمن قرارات مالية ذكية</p>
          </div>
      </>
  )
}

export default AccountSystem